<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
console.log('CUSTOM JS CARGADO ✅');
let lastActiveCard = null;

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.swatch-label');
  if (!swatch) return;

  const variantImage = swatch.dataset.variantImage;
  if (!variantImage) return;

  const card = swatch.closest('.card-product, .product-card, .product-item');
  if (!card) return;

  const mainImage = card.querySelector('.card-media img');
  if (!mainImage) return;

  /* 🔁 RESTAURAR CARD ANTERIOR */
  if (lastActiveCard && lastActiveCard !== card) {
    const previousImage = lastActiveCard.querySelector('.card-media img');

    if (previousImage && previousImage.dataset.originalSrc) {
      previousImage.src = previousImage.dataset.originalSrc;
      previousImage.srcset = previousImage.dataset.originalSrc;
    }

    lastActiveCard
      .querySelectorAll('.swatch-label')
      .forEach(el => el.classList.remove('is-active'));
  }

  /* 💾 GUARDAR IMAGEN ORIGINAL (solo una vez) */
  if (!mainImage.dataset.originalSrc) {
    mainImage.dataset.originalSrc = mainImage.src;
  }

  /* 🔄 CAMBIAR IMAGEN POR VARIANTE */
  mainImage.src = variantImage;
  mainImage.srcset = variantImage;

  /* 🎯 ESTADO ACTIVO */
  card.querySelectorAll('.swatch-label').forEach(el =>
    el.classList.remove('is-active')
  );
  swatch.classList.add('is-active');

  /* 🧠 RECORDAR CARD ACTUAL */
  lastActiveCard = card;
});

